import React, { useState, useRef } from "react";
import "./EnterpriseCaseStudy.css";
import "../../../Common Components/Hero.css";
import EdelweissFinancialsCaseStudy from "../../../assets/pdf/EdelweissFinancialsCaseStudy.pdf";
import CaseStudyIndividualPage from "../../../assets/images/CaseStudyIndividualPage.jpg";

const Edelweiss = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const emailInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userEmail = emailInputRef.current.value;
    const formUrl = `https://docs.google.com/forms/d/e/1FAIpQLScCh_Wn_mi8GlNCFJg0xw82iFGq9m3a7Z2STUBKRA2sSh9TKQ/formResponse`;

    // Construct query parameters
    const formData = new URLSearchParams();
    formData.append("entry.1812720550", "Edelweiss case study downloaded"); // Name
    formData.append("entry.1870394174", userEmail); // Email
    formData.append("entry.97349512", "Edelweiss case study downloaded"); // Phone
    formData.append("entry.231532781", "Edelweiss case study downloaded"); // Message

    try {
      // Submit the form data using Fetch API
      await fetch(formUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      // Show the download button upon successful submission
      setShowPopup(false);
      setShowDownloadPopup(true);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setShowDownloadPopup(false);
  };

  const handleDownloadPDF = () => {
    const link = document.createElement("a");
    link.href = EdelweissFinancialsCaseStudy;
    link.setAttribute("download", "Edelweiss Financials Case Study.pdf");
    link.click();
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
    setShowDownloadPopup(false);
  };

  return (
    <div className="Individual-CaseStudy-Div">
      <div
        className="ImageBackgroundWrap Background-fixed"
        style={{
          backgroundImage: `url(${CaseStudyIndividualPage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="ImageInnerWrap"></div>
      </div>

      <div className="headline" id="CaseStudyDv">
        <h1>EDELWEISS FINANCIAL</h1>
      </div>
      <div className="case-study-div">
        <div className="case-study">
          <h2 className="case-study-title">A leading trading organization.</h2>
          <div className="case-study-table">
            <table>
              <tbody>
                <tr>
                  <td className="table-label">Assignment name:</td>
                  <td>Designing of DC and greenfield IT network setup</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Approx. value of the contract:
                  </td>
                  <td>INR 10,00,000</td>
                </tr>
                <tr>
                  <td className="table-label">Country:</td>
                  <td>India</td>
                </tr>
                <tr>
                  <td className="table-label">Location within country:</td>
                  <td>Mumbai</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Duration of assignment (months):
                  </td>
                  <td>2</td>
                </tr>
                <tr>
                  <td className="table-label">Name of client:</td>
                  <td>Edelweiss Finance Group</td>
                </tr>
                <tr>
                  <td className="table-label">
                    Name of senior professional staff of your firm involved and
                    functions performed:
                  </td>
                  <td>
                    Mr. Srinivas Rao – Principal Technical Consultant Mr.
                    Debankur Basu – Senior Technical Consultant Mr. Abhishek
                    Trivedi – Lead Technical Consultant
                  </td>
                </tr>
                <tr>
                  <td className="table-label">
                    Approx. value of the services provided by your firm under
                    the contract:
                  </td>
                  <td>INR 10,00,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button className="read-more-btn" onClick={handleOpenPopup}>
            Read More
          </button>
          {showPopup && (
            <div className="popup">
              <button className="close-btn" onClick={handleClosePopup}>
                Close
              </button>
              <p className="popup-message">
                Want to read more of this case study? Please give us your email:
              </p>
              <form onSubmit={handleSubmit} className="email-form">
                <input
                  type="email"
                  ref={emailInputRef}
                  name="email"
                  placeholder="Enter your email"
                  required
                />
                <button type="submit">Submit</button>
              </form>
            </div>
          )}
          {showDownloadPopup && (
            <div className="popup">
              <button className="close-btn" onClick={handleClosePopup}>
                Close
              </button>
              <p>
                Thank you for your email. Your case study PDF is ready for
                download:
              </p>
              <div className="download-button-container">
                <button className="download-btn" onClick={handleDownloadPDF}>
                  Download PDF
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Edelweiss;
